import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';

import { AuthService } from '../core/auth.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { Unlockdconfig } from '../../unlockd.config';
import { map } from 'rxjs/operators';
import { url } from 'inspector';

/**
 * Api services for the `Documents` model.
 */
@Injectable()
export class DocumentApi {
  constructor(protected http: HttpClient, private authService: AuthService) {}
  // api/documents/:document_id/form PUT

  public updateDocument(document_id: string, object): Observable<any> {
    const url = Unlockdconfig.getPath() + `/documents/${document_id}/forms`;

    return this.http.put(url, object, {
      headers: new HttpHeaders().set(
        'Authorization',
        this.authService.getAccessTokenId()
      )
    });
  }
  public processDocument(
    document_id: string,
    selected_form_id: string,
    listing_id: string,
    image_blob: any,
    signee: string,
  ): Observable<any> {
    const url = Unlockdconfig.getPath() +`/documents/${document_id}/populate`;
    const formData: FormData = new FormData();
    formData.append('signature', image_blob, 'signature.png');
    formData.append('listing_id', listing_id);
    formData.append('form_id', selected_form_id);
    formData.append('signee', signee);
    return this.http.post(url, formData, {
      headers: new HttpHeaders().set(
        'Authorization',
        this.authService.getAccessTokenId()
      )
    });
  }
  public signDocument(
    document_id: string,
    selected_form_id: string,
    listing_id: string,
    // signee: string = 'seller_sign_1'
    signee:string,
  ): Observable<any> {
    // console.log('signee is',signee)
    // Unlockdconfig.getPath() + 
    const url =Unlockdconfig.getPath()+`/documents/${document_id}/signature`;
    // const url = `http://192.168.10.191:8083/api/documents/${document_id}/signature`;

    const object = {
      listing_id,
      signee,
      form_id: selected_form_id
    };

    return this.http.post(url, object, {
      headers: new HttpHeaders().set(
        'Authorization',
        this.authService.getAccessTokenId()
      )
    });
  }

  public signDocumentAdmin(
    document_id: string,
    selected_form_id: string,
    listing_id: string,
    signee: string = 'agent_sign_1'
  ): Observable<any> {
    // Unlockdconfig.getPath() +
    const url = Unlockdconfig.getPath() + `/admin/${document_id}/signature`;
    // console.log('document_Id',document_id,'selectedForm_id',selected_form_id,'listing_id:',listing_id,'signee',signee)

    const object = {
      listing_id,
      signee,
      form_id: selected_form_id
    };

    return this.http.post(url, object, {
      headers: new HttpHeaders().set(
        'Authorization',
        this.authService.getAccessTokenId()
      )
    });
  }
  public addDocumentInitial(
    document_id: string,
    selected_form_id: string,
    listing_id: string,
    initials: string
  ): Observable<any> {
    const url = Unlockdconfig.getPath() + `/documents/${document_id}/initials`;

    const object = {
      listing_id,
      form_id: selected_form_id,
      initials: initials
    };

    return this.http.post(url, object, {
      headers: new HttpHeaders().set(
        'Authorization',
        this.authService.getAccessTokenId()
      )
    });
  }

  public getDocumentDetails(document_id: string): Observable<any> {
    const url = Unlockdconfig.getPath() + `/documents/${document_id}/forms`;

    return this.http.get(url, {
      headers: new HttpHeaders().set(
        'Authorization',
        this.authService.getAccessTokenId()
      )
    });
  }
  public getDocumentLogsByFormId(
    document_id: string,
    form_id: string,
    paginationObj
  ): Observable<any> {
    const { start, size } = paginationObj;
    const url =
      Unlockdconfig.getPath() + `/documents/${document_id}/logs/${form_id}`;
    return this.http
      .get(url, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        )
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }
  public deleteDocumentByIdAndNumber(_id: string,number:number,deletion_password:string): Observable<any> {
    const url = Unlockdconfig.getPath() + `/documents/${_id}/number/${number}`;
    const body = {
      deletion_password: deletion_password
    };
    const header: HttpHeaders = new HttpHeaders()
                .append('Authorization', this.authService.getAccessTokenId());
    const httpOptions = {
        headers: header,
        body: body
    };

    return this.http.delete(url, httpOptions);
  }
  public sendSeller2Signature(documentId,user_id,image_blob,signee){
  //  const body = {
  //   document_id:documentId,
  //   _id:user_id,
  //   signature:image_blob,
  //   signee:signee
  //   }
  const formData: FormData = new FormData();
    formData.append('signature', image_blob, 'signature.png');
    formData.append('documentId', documentId);
    formData.append('user_id', user_id);
    formData.append('signee', signee);
    const url = Unlockdconfig.getPath() + `/documents/${user_id}/signature/addSeller2`
    return this.http.post(url,formData, {
      headers: new HttpHeaders().set(
        'Authorization',
        this.authService.getAccessTokenId()
      )
    });
  }
}
